export default "__VITE_ASSET__CqOmY3K___"